// @flow

declare type MessageDescriptor = {|
  id: string,
  defaultMessage: string,
  description?: string,
|};

declare type MessageDescriptorMap<K: string> = {[key: K]: MessageDescriptor};

export const noTranslateMessages = <K: string>(
  messages: MessageDescriptorMap<K>,
): MessageDescriptorMap<K> => messages;
